module.exports = __webpack_public_path__ + "media/images/hitfun/icon.prize.material-4114aef6126a0eea96e15adbcc500f7a.svg";